import {computed} from "vue";

const useSafekeepOrder = () => {
  const route = useRoute()

  // true, если это функционал "Ответственного хранения" (заказ, список заказов и тд) 
  const isOrderSafekeepMode = computed(() => {
    return route.path && (route.path as string).includes('/safekeep')
  })

  return {
    isOrderSafekeepMode
  }
}

export default useSafekeepOrder
